import React, {useEffect, useRef } from 'react';
import { Backdrop, Tooltip } from "../../index";
import './tooltip.scss';

export const TooltipSpotlight = ({
    children,
    text,
    tooltip,
    tooltipId,
    linkText,
    open,
    placement,
    linkOnClick = () => { },
}) => {

    return (<>
                {open && <Backdrop onClick={linkOnClick} />}
                <div className={`bsw-tooltip__child ${open ? 'bsw-tooltip-show' : ''}`}>
                    {tooltip}
                </div>
            </>
    );
}
